var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.loading)?_c('a-spin',{staticClass:"home-loading",attrs:{"size":"large"}}):_vm._e(),(_vm.isShow)?_c('div',{staticClass:"home-warp"},[_c('div',{staticClass:"home-warp-box"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }